import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-polyglot'
import { BrowserView, MobileView } from 'react-device-detect'
import moment from 'moment'
import Tippy from '@tippy.js/react'
import history from 'configureHistory'
import EE from 'emitter.js'

import {
	FormLabel,
	Avatar,
	FlexContainer,
	Text,
	Icon,
	ButtonGroup,
	Button,
	Confirm,
	Tooltip,
} from 'components'

import {
	getWordCount,
	getCharacterCount,
	getEmojiCount,
	getReadingTime,
} from '../../utils'

import './metaData.scss'

class MetaData extends Component {
	metaData = React.createRef()

	constructor(props) {
		super(props)

		this.state = {
			emojiCount: 0,
			emojiRanking: '🙁',
			characterCount: 0,
			wordCount: 0,
			displayReadingTime: 0,
			// createdBy: '',
			updatedBy: '',
			// createdAtDisplayTime: '',
			updatedAtDisplayTime: '',
			updatedTime: null,
		}
	}

	componentDidMount() {
		this.setState({ updatedTime: this.getUpdatedAtDisplayTime() })

		this.interval = setInterval(this.updateTime, 30000)
	}

	componentDidUpdate(prevProps) {
		const {
			meta: { updatedAt },
			loading,
		} = this.props

		if (
			(updatedAt || prevProps.meta.updatedAt) &&
			((!loading && !prevProps.meta.updatedAt) ||
				updatedAt !== prevProps.meta.updatedAt)
		) {
			this.updateTime()
		}
	}

	componentWillUnmount() {
		clearInterval(this.interval)
	}

	onCreateActionsTippy = tippy => {
		this.actionsTippy = tippy
	}

	onCreateMetaDataTippy = tippy => {
		this.metaDataTippy = tippy
	}

	closeActionsTippy = () => {
		this.actionsTippy.hide()
	}

	closeMetaDataTippy = () => {
		this.metaDataTippy.hide()
	}

	updateTime = () => {
		this.setState({ updatedTime: this.getUpdatedAtDisplayTime() })
	}

	getUpdatedAtDisplayTime = () => {
		let {
			meta: { createdAt, updatedAt },
		} = this.props

		createdAt = moment(createdAt)
		updatedAt = moment(updatedAt)

		if (updatedAt && updatedAt >= moment()) {
			updatedAt = moment() - 1
		}

		if (createdAt && createdAt >= moment()) {
			createdAt = moment() - 1
		}

		return updatedAt ? moment().to(updatedAt) : moment().to(createdAt)
	}

	openResponsiblePersonsModal = () => {
		const {
			meta: { id, createdBy, responsibleMembers },
		} = this.props

		EE.emit('showResponsiblePersonsModal', {
			articleId: id,
			articleCreator: createdBy ? createdBy.id : null,
			responsibleMembers,
		})
	}

	openFeedbackModal = () => {
		const {
			meta: { id, responsibleMembers },
		} = this.props

		EE.emit('showFeedbackModal', {
			articleId: id,
			responsibleMembers,
		})
	}

	renderHtml = () => {
		const {
			emojiCount,
			emojiRanking,
			characterCount,
			wordCount,
			displayReadingTime,
			// createdBy,
			updatedBy,
			// createdAtDisplayTime,
			updatedAtDisplayTime,
		} = this.state

		const {
			meta: { id, userId, createdBy, responsibleMembers },
			t,
		} = this.props

		const updatedByDisplayName = updatedBy
			? `${updatedBy.firstName} ${updatedBy.lastName}`
			: t('deleted_user')

		const responsibleMemberDisplayName =
			responsibleMembers && responsibleMembers.length === 1
				? `${responsibleMembers[0].firstName} ${responsibleMembers[0].lastName}`
				: t('deleted_user')

		const responsibleMemberInitials =
			responsibleMembers && responsibleMembers.length === 1
				? responsibleMembers[0].firstName.charAt(0) +
				  responsibleMembers[0].lastName.charAt(0)
				: 'n/a'

		return (
			<>
				<div className="c-editor-meta__cols">
					<div className="c-editor-meta__col">
						<div className="c-editor-meta__item">
							<div className="c-editor-meta__title">
								{t('responsible_persons')}
							</div>
							<FlexContainer justifyContent="flex-start">
								{(!responsibleMembers ||
									responsibleMembers.length === 0) && [
									<Avatar
										initials="EL"
										image="assets/img/mr-svensson.png"
										imageSrc="local"
										key="1"
									/>,
									<div
										className="c-editor-meta__text"
										key="2"
									>
										Mr. Svensson
									</div>,
								]}
								{responsibleMembers &&
									responsibleMembers.length === 1 && (
										<Avatar
											initials={responsibleMemberInitials}
											image={
												responsibleMembers[0] &&
												responsibleMembers[0].image
													? responsibleMembers[0]
															.image
													: null
											}
										/>
									)}
								{responsibleMembers &&
									responsibleMembers.length === 1 && (
										<div className="c-editor-meta__text">
											{responsibleMemberDisplayName}
										</div>
									)}
								{responsibleMembers &&
									responsibleMembers.length > 1 && (
										<Tooltip
											description={responsibleMembers.map(
												m => {
													const name = m
														? `${m.firstName} ${m.lastName}`
														: 'n/a'
													return (
														<span key={m.id}>
															{name}
															<br />
														</span>
													)
												}
											)}
										>
											<>
												{responsibleMembers
													.slice(0, 4)
													.map(m => {
														const initials = m
															? m.firstName.charAt(
																	0
															  ) +
															  m.lastName.charAt(
																	0
															  )
															: 'n/a'
														return (
															<Avatar
																key={m.id}
																initials={
																	initials
																}
																image={m.image}
															/>
														)
													})}
												{responsibleMembers.length >
													4 && (
													<Avatar initials="…" />
												)}
											</>
										</Tooltip>
									)}
								{responsibleMembers &&
									responsibleMembers.length > 1 && (
										<div className="c-editor-meta__text">
											{responsibleMembers.length}{' '}
											{t('members')}
										</div>
									)}
								<Button
									icon={<Icon name="edit-pen" />}
									onClick={() => {
										this.closeMetaDataTippy()
										this.openResponsiblePersonsModal()
									}}
									layout="text"
								/>
							</FlexContainer>
						</div>
						<div className="c-editor-meta__item">
							<div className="c-editor-meta__title">
								{t('updated_at', {
									time: updatedAtDisplayTime,
								})}
							</div>
							<div className="c-editor-meta__text">
								{t('by_name', {
									name: updatedByDisplayName,
								})}
							</div>
						</div>
					</div>
					<div className="c-editor-meta__col">
						<div className="grid" data-grid="normal">
							<div className="grid__item" data-grid="6/12">
								<div className="c-editor-meta__title">
									{wordCount}
								</div>
								<div className="c-editor-meta__text">
									{t('words')}
								</div>
							</div>
							<div className="grid__item" data-grid="6/12">
								<div className="c-editor-meta__title">
									{characterCount}
								</div>
								<div className="c-editor-meta__text">
									{t('characters')}
								</div>
							</div>
							<div className="grid__item" data-grid="6/12">
								<div className="c-editor-meta__title">
									{displayReadingTime} {t('minutes_short')}
								</div>
								<div className="c-editor-meta__text">
									{t('reading_time')}
								</div>
							</div>
							<div className="grid__item" data-grid="6/12">
								<div className="c-editor-meta__title">
									{emojiCount}
								</div>
								<div className="c-editor-meta__text">
									{t('emojis')} {emojiRanking}
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		)
	}

	render() {
		const { updatedTime } = this.state

		const {
			meta: { id, ratings, userId },
			lockedBy,
			draft,
			outdated,
			onRemove,
			onDraftStateChange,
			onChangeOutdatedState,
			onDuplicate,
			onRate,
			loading,
			t,
		} = this.props

		const upVotes = ratings.filter(rating => rating.like)
		const downVotes = ratings.filter(rating => !rating.like)
		const currentUserUpvoted = upVotes.find(
			rating => rating.user === userId
		)
		const currentUserDownvoted = downVotes.find(
			rating => rating.user === userId
		)
		const lockedByOtherUser = lockedBy && lockedBy.id !== userId

		return (
			<div
				className={
					loading
						? 'c-editor-meta c-editor-meta--loading'
						: 'c-editor-meta'
				}
				ref={this.metaData}
			>
				<Tippy
					appendTo={this.metaData.current}
					content={this.renderHtml()}
					trigger="click"
					interactive
					placement="bottom-start"
					theme="editor-meta"
					animation="shift-away"
					animateFill={false}
					size="small"
					ignoreAttributes
					maxWidth=""
					a11y={false}
					onCreate={this.onCreateMetaDataTippy}
					zIndex="9997"
					onShow={() => {
						const { meta, value } = this.props
						const { createdBy, updatedBy } = meta
						let { createdAt, updatedAt } = meta

						createdAt = moment(createdAt)
						updatedAt = moment(updatedAt)

						if (updatedAt && updatedAt >= moment()) {
							updatedAt = moment() - 1
						}

						if (createdAt && createdAt >= moment()) {
							createdAt = moment() - 1
						}

						const wordCount = getWordCount(value)
						const characterCount = getCharacterCount(
							value.replace(/\n/g, '')
						)
						const emojiCount = getEmojiCount(value)
						const emojiWordRatio =
							(100 * emojiCount) / (wordCount + emojiCount)

						let emojiRanking = '😞'

						if (
							emojiWordRatio === 100 ||
							emojiWordRatio === Infinity
						) {
							emojiRanking = '🤣'
						} else if (emojiWordRatio >= 50) {
							emojiRanking = '😂'
						} else if (emojiWordRatio >= 10) {
							emojiRanking = '😄'
						} else if (emojiCount > 1) {
							emojiRanking = '🙂'
						} else if (emojiCount === 1) {
							emojiRanking = '😐'
						}

						const readingTime = getReadingTime(value)
						let displayReadingTime = 0

						if (readingTime.minutes) {
							displayReadingTime = Math.ceil(
								readingTime.minutes.toFixed(2)
							)
						}

						this.setState({
							emojiCount,
							emojiRanking,
							characterCount,
							wordCount,
							displayReadingTime,
							// createdBy,
							updatedBy: updatedBy || createdBy,
							// createdAtDisplayTime: moment().to(createdAt),
							updatedAtDisplayTime: this.getUpdatedAtDisplayTime(),
						})
					}}
				>
					<Text inline>
						<MobileView renderWithFragment>
							<Button
								icon={<Icon name="info" />}
								tabIndex="-1"
								layout="text"
							/>
						</MobileView>
						<BrowserView renderWithFragment>
							<Button
								icon={<Icon name="info" />}
								text={t('updated_at', { time: updatedTime })}
								tabIndex="-1"
								layout="text"
							/>
						</BrowserView>
					</Text>
				</Tippy>
				<Text inline>
					<Button
						icon={<Icon name="thumbs-up" />}
						text={upVotes.length > 0 && upVotes.length}
						tabIndex="-1"
						onClick={() => onRate(id, true)}
						layout="text"
						className={currentUserUpvoted && 'is-active'}
					/>
				</Text>
				<Text inline>
					<Button
						icon={<Icon name="thumbs-down" />}
						text={downVotes.length > 0 && downVotes.length}
						tabIndex="-1"
						onClick={() => onRate(id, false)}
						layout="text"
						className={currentUserDownvoted && 'is-active'}
					/>
				</Text>

				{!lockedByOtherUser && (
					<Tippy
						placement="right-start"
						trigger="click"
						animation="shift-away"
						animateFill={false}
						theme="min-width-small"
						interactive
						a11y={false}
						onCreate={this.onCreateActionsTippy}
						content={
							<ButtonGroup>
								<Button
									text={t('status.draft')}
									icon={<Icon name="draft" />}
									layout="tertiary"
									fullWidth
									size="small"
									onClick={e => {
										e.stopPropagation()

										onDraftStateChange(id, !draft)

										this.closeActionsTippy()
									}}
									metaContent={
										<>
											<input
												className="o-switch__input"
												type="checkbox"
												checked={!!draft}
												readOnly
											/>
											<FormLabel className="o-switch__label" />
										</>
									}
								/>
								<Confirm
									text={
										outdated
											? t('tag_as_current_text')
											: t('tag_as_outdated_text')
									}
									buttonText={
										outdated
											? t('tag_as_current_button')
											: t('tag_as_outdated_button')
									}
									buttonLayout="primary"
									onOpen={() => {
										this.closeActionsTippy()
									}}
								>
									{confirm => (
										<Button
											text={t('status.outdated')}
											icon={<Icon name="outdated" />}
											layout="tertiary"
											fullWidth
											size="small"
											onClick={confirm(() => {
												onChangeOutdatedState(
													id,
													!outdated
												)
											})}
											metaContent={
												<>
													<input
														className="o-switch__input"
														type="checkbox"
														checked={!!outdated}
														readOnly
													/>
													<FormLabel className="o-switch__label" />
												</>
											}
										/>
									)}
								</Confirm>
								<hr className="o-button-group__divider" />
								<Button
									onClick={() => {
										this.closeActionsTippy()
										this.openFeedbackModal()
									}}
									text={t('give_feedback')}
									icon={<Icon name="feedback" />}
									size="small"
									layout="tertiary"
									fullWidth
								/>
								<Button
									onClick={() => {
										this.closeActionsTippy()

										history.push({
											hash: '#editing-history',
										})
									}}
									text={t('editing_history')}
									icon={<Icon name="editing-history" />}
									size="small"
									// label={<Label text="Pro" theme="important" />}
									layout="tertiary"
									fullWidth
								/>
								<Button
									onClick={() => {
										this.closeActionsTippy()
										this.openResponsiblePersonsModal()
									}}
									text={t('responsible_persons')}
									icon={<Icon name="responsible" />}
									size="small"
									layout="tertiary"
									fullWidth
								/>
								<hr className="o-button-group__divider" />
								<Button
									text={t('duplicate')}
									icon={<Icon name="duplicate" />}
									layout="tertiary"
									fullWidth
									size="small"
									onClick={() => {
										onDuplicate(id)

										this.closeActionsTippy()
									}}
								/>
								<Confirm
									text={t('delete_question')}
									buttonText={t('delete_long')}
									onOpen={() => {
										this.closeActionsTippy()
									}}
								>
									{confirm => (
										<Button
											text={t('delete')}
											icon={<Icon name="delete" />}
											layout="tertiary"
											fullWidth
											size="small"
											onClick={confirm(() => {
												onRemove(id)
											})}
										/>
									)}
								</Confirm>
							</ButtonGroup>
						}
					>
						<Button
							tabIndex="-1"
							icon={<Icon name="dot-3" />}
							className="o-text--inline"
						/>
					</Tippy>
				)}
			</div>
		)
	}
}

MetaData.propTypes = {
	meta: PropTypes.shape({
		createdAt: PropTypes.string,
		createdBy: PropTypes.object,
		updatedAt: PropTypes.string,
		updatedBy: PropTypes.object,
	}),
	value: PropTypes.string.isRequired,
	loading: PropTypes.bool,
}

MetaData.defaultProps = {
	meta: {
		createdAt: 0,
		createdBy: '',
		updatedAt: 0,
		updatedBy: '',
	},
	loading: false,
}

export default translate()(MetaData)
